export default __webpack_public_path__ + "static/3-65429bb45eab304491b81bb17c359503.svg";